import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getCustomers = () =>
  axiosInstance.get(`${LANDING_API_URL}/landing-customers`, {
    headers: authHeaders(),
  });

export const getSectors = () =>
  axiosInstance.get(`${LANDING_API_URL}/sectors`, {
    headers: authHeaders(),
  });

export const createCustomerRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/landing-customers`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateCustomerRequest = (id, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/landing-customers/${id}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeCustomer = (customerId) =>
  axiosInstance.delete(`${LANDING_API_URL}/landing-customers/${customerId}`, {
    headers: authHeaders(),
  });
